module.exports = __webpack_public_path__ + "static/media/EventFlow2.e99bf176.jpg";